import type { DocumentNode } from 'graphql';
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries';
import { usePregeneratedHashes as createHashGenerator } from 'graphql-codegen-persisted-query-ids/lib/apollo';
import persistedQueriesData from 'generated/persisted-queries.json';

/**
 * Adds support for persisted queries using pregenerated hashes.
 */
const hashGenerator = createHashGenerator(persistedQueriesData) as unknown as (
  document: DocumentNode
) => string;

export const persistedQueryLink = createPersistedQueryLink({
  generateHash: hashGenerator,
  disable: ({ meta }) => {
    return meta.persistedQueryNotFound;
  },
});
